module.exports = __webpack_public_path__ + "img/kfptsBanner.3342aa3c.svg";